import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentSelectedPort: sessionStorage.getItem("currentLocation") || "All",
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setPortLocation: (state, action) => {
      state.currentSelectedPort = action.payload;

      // persist in sessionStorage
      sessionStorage.setItem("currentLocation", action.payload);
    },
  },
});

export const { setPortLocation } = locationSlice.actions;

export default locationSlice.reducer;
